export enum SharesTargets {
  FORECASTS = 'forecasts',
  CUSTOM_REPORT_TEMPLATES = 'custom_report_templates',
  PDF_CUSTOM_REPORT_TEMPLATES = 'pdf_custom_report_templates',
}

export type SearchSharesUsersPayload = {
  targetId: number;
  targetTable: SharesTargets;
  query: string;
};

export type ShareTargetPayload = {
  targetId: number;
  targetTable: SharesTargets;
  receivingUserIds: number[];
};

export type SharesMeta = {
  id: number;
  receivingUserId: number;
  shareUserId: number;
  targetId: number;
  targetTable: SharesTargets;
};
